var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCalendarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 6.07 6.07 1.25 12 1.25S22.75 6.07 22.75 12 17.93 22.75 12 22.75 1.25 17.93 1.25 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75 2.75 6.9 2.75 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14 7.83v-2c0-.41.34-.75.75-.75s.75.34.75.75v2a.749.749 0 1 1-1.5 0zM13.36 7.83v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM7.52 10.89c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.95a.749.749 0 1 1 0 1.5H7.52z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.42c-2.75 0-4.75-2-4.75-4.75v-3c0-2.75 2-4.75 4.75-4.75h3c2.75 0 4.75 2 4.75 4.75v3c0 2.75-2 4.75-4.75 4.75h-3zm-3.25-7.75v3c0 1.62 1 3.25 3.25 3.25h3c2.25 0 3.25-1.63 3.25-3.25v-3c0-1.62-1-3.25-3.25-3.25h-3c-2.25 0-3.25 1.63-3.25 3.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCalendarCircle);
export default __webpack_public_path__ + "static/media/vuesax-outline-calendar-circle.24b33d203897c5162982d79c074cdd24.svg";
export { ForwardRef as ReactComponent };